import React, { Component } from 'react';
import Button1 from './Button';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';

class ConfirmDialog extends Component {
  state = { open: true };

  handleCancel = () => {
    this.props.onCancel?.();
    this.setState({ open: false });
  };

  handleOk = () => {
    this.props.onOk?.();
    this.setState({ open: false });
  };

  handleDownload = () => {
    this.props.onDownload?.();
    this.setState({ open: false });
  };

  render() {
    const { t, title, hideCancel, CancelText, isDownload, OkText, disabled, children } = this.props;

    return (
      <Dialog
        disableBackdropClick
        disableEscapeKeyDown
        aria-labelledby="confirmation-dialog-title"
        open={this.state.open}
        maxWidth={this.props.maxWidth}
      >
        {title && <DialogTitle id="confirmation-dialog-title">{title}</DialogTitle>}
        <DialogContent>{children}</DialogContent>
        <DialogActions>
          {!hideCancel && (
            <Button1 onClick={this.handleCancel} className="button-white">
              {CancelText ? t(CancelText) : t('Cancel')}
            </Button1>
          )}
          {isDownload && (
            <Button1 onClick={this.handleDownload} style={{ backgroundColor: '#00C179' }}>
              {t('Download QR')}
            </Button1>
          )}
          <Button1 disabled={disabled} onClick={this.handleOk} color="primary" style={{ minWidth: 60 }}>
            {OkText ? t(OkText) : t('Ok')}
          </Button1>
        </DialogActions>
      </Dialog>
    );
  }
}

const mapStateToProps = state => ({ /* if needed */ });

export default compose(
  connect(mapStateToProps),
  withTranslation()
)(ConfirmDialog);
